import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getPrefferedSPIMethod.query';

export const getSubProgramPreferenceProgressScurve = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSubProgramPreferenceProgressScurve${querystring}`;
    return network.get(url).then((response) => response.data);
};
